import _ from 'underscore';
import { convertEnumValuetoLegacy, convertEnumValuetoLegacyString } from '@bingads-webui/filter-entity';

const EnumPropertyToTypeMapping = {
  AudienceStatus: ['AdGroupCriterionStatus'],
  BidTarget: ['BidTargetType'],
  BidType: ['BidType'],
  CampaignType: ['CampaignType'],
  CallTrackingStatus: ['AdGroupCallTrackingStatus'],
  DeliveryStatus: ['DeliveryStatus'],
  DevicePreference: ['DevicePreference'],
  DisplayBiddingStrategyType: ['BiddingStrategyType'],
  Language: ['Language'],
  Medium: ['Medium'],
  Status: ['CampaignStatus', 'AdGroupStatus', 'AudienceStatus', 'AdStatus'],
  Type: ['AdType'],
  MatchType: ['MatchType'],
  AvailableInsightTypeIds: ['FluctuationType'],
  AdGroupType: ['SearchStandard', 'SearchDynamic', null],
  CampaignCashbackScope: ['None', 'Store', 'Product'],
  AdGroupCashbackScope: ['None', 'Store', 'Product'],
  Coupon: ['None', 'Enabled', 'Disabled'],
};
const EnumPropertyToStringTypeMapping = [
  'AudienceType',
];

function toLegacyEnum(value, property) {
  const types = EnumPropertyToTypeMapping[property];
  let legacyValue = null;

  if (_.size(types) > 0) {
    legacyValue = convertEnumValuetoLegacy(value);

    if (legacyValue) {
      return legacyValue;
    }
  }

  if (_.contains(EnumPropertyToStringTypeMapping, property)) {
    legacyValue = convertEnumValuetoLegacyString(value);
  }

  return legacyValue;
}

function toLegacyOperator(op, col, schema) {
  let ret = op || '$eq';

  switch (ret) {
    case '$contains':
      ret = 'Contains';
      break;
    case '$doesnotcontain':
      ret = 'DoesNotContain';
      break;
    case '$startswith':
      ret = 'BeginsWith';
      break;
    case '$endswith':
      ret = 'EndsWith';
      break;
    case '$eq':
      ret = 'Equal';
      break;
    case '$neq':
      ret = 'NotEqual';
      break;
    case '$gt':
      ret = 'Greater';
      break;
    case '$gte':
      ret = 'GreaterOrEqual';
      break;
    case '$lt':
      ret = 'Less';
      break;
    case '$lte':
      ret = 'LessOrEqual';
      break;
    case '$in':
      if (_.isEmpty(schema.properties[col].enum) &&
          _.isEmpty(schema.properties[col].groupedItems)) {
        ret = 'Equal';
      } else {
        ret = 'EnumSelection';
      }
      break;
    case '$containsall':
      ret = 'ContainsAll';
      break;
    case '$containsany':
      ret = 'ContainsAny';
      break;
    case '$containsnone':
      ret = 'ContainsNone';
      break;
    default:
      break;
  }

  return ret;
}

function toLegacyColumn(col, filterSchema) {
  return filterSchema ? filterSchema.toAlias(col, 'legacy') : col;
}

function toLegacyValue(values, col, schema, i18n) {
  if (schema.properties[col]) {
    if (!_.isEmpty(schema.properties[col].enum) ||
      !_.isEmpty(schema.properties[col].groupedItems)) {
      return _.map(values, value => toLegacyEnum(value, col));
    } else if (schema.properties[col].type === 'boolean') {
      return _.map(values, value => (value === true ? 1 : 0));
    } else if (schema.properties[col].type === 'datetime') {
      return _.map(values, value => (i18n.formatDate(value, { raw: 'MM/dd/yyyy' })));
    }
  }

  return values;
}

/**
 * Converting filterEntity to Legacy filter
 *
 * @param {Object} filterentity - an instance of FilterEntity from @webui/filter-entity
 * @param {Object} i18n - the localization settings with formatDate support
 * @param {Object} i18n.formatDate - format Date time
 * @returns {Object} legacy filter in format of {SelectedColumn, SelectedOperator, Values}
 */
export function fromFilterEntityToLegacyFilter(filterentity, i18n) {
  const translateToLegacyFormat = function (query) {
    const condition = _.pairs(query)[0][1];
    const operator = _.pairs(condition)[0][0];
    let value = _.pairs(condition)[0][1];

    if (!_.isArray(value)) {
      value = [value];
    }

    return {
      SelectedColumn: _.pairs(query)[0][0],
      SelectedOperator: operator,
      Values: value,
    };
  };

  let schema;
  let legacyFormats;


  if (filterentity && filterentity.query && !_.isEmpty(filterentity.query)) {
    schema = filterentity.options ?
      filterentity.options.entitySchema :
      filterentity.schema.entitySchema;

    if (filterentity.query.$and && filterentity.query.$and.length > 0) {
      legacyFormats = _.map(filterentity.query.$and, query => translateToLegacyFormat(query));
    } else {
      legacyFormats = [translateToLegacyFormat(filterentity.query)];
    }
  }

  if (!_.isArray(legacyFormats)) {
    return null;
  }

  return _.map(legacyFormats, (legacyFormat) => {
    const col = legacyFormat.SelectedColumn;

    return {
      SelectedColumn: toLegacyColumn(col, filterentity.schema),
      SelectedOperator: toLegacyOperator(legacyFormat.SelectedOperator, col, schema),
      Values: toLegacyValue(legacyFormat.Values, col, schema, i18n),
    };
  });
}
